var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table mt-0 table-sm table-hover" }, [
      _c("thead", [
        _c("tr", [
          _c("th"),
          _vm._v(" "),
          _c("th", [
            _c("input", {
              attrs: { type: "checkbox" },
              on: { change: _vm.selectAll },
            }),
          ]),
          _vm._v(" "),
          _c("th", [_vm._v("ID")]),
          _vm._v(" "),
          _c("th", [_vm._v("Клиент")]),
          _vm._v(" "),
          _c("th", [_vm._v("Адрес")]),
          _vm._v(" "),
          _c("th", [_vm._v("Препараты")]),
          _vm._v(" "),
          _c("th"),
          _vm._v(" "),
          _c("th", [_vm._v("Вес (гр)")]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.orders, function (o, i) {
          return _c("tr", { key: i }, [
            _c("td", [
              _vm._v(
                _vm._s(
                  i +
                    1 +
                    (_vm.paginator.current_page - 1) * _vm.paginator.per_page
                )
              ),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedOrders[o.id],
                    expression: "selectedOrders[o.id]",
                  },
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.selectedOrders[o.id])
                    ? _vm._i(_vm.selectedOrders[o.id], null) > -1
                    : _vm.selectedOrders[o.id],
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.selectedOrders[o.id],
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.selectedOrders, o.id, $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.selectedOrders,
                            o.id,
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.selectedOrders, o.id, $$c)
                    }
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(o.id) + "\n        "),
              o.date_order
                ? _c("p", { staticClass: "text-muted fs-12" }, [
                    _vm._v(_vm._s(_vm.printDate(o.date_order))),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("p", [_vm._v(_vm._s(o.client_name))]),
                _vm._v(" "),
                _vm._l(o.order_phones, function (phone) {
                  return _c("p", [
                    _vm._v(_vm._s(_vm.mixinPrintPhone(phone.phone.phone))),
                  ])
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("td", [
              _c("p", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      (_vm.$AllCities[o.city_id] &&
                        _vm.$AllCities[o.city_id].name) ||
                        o.city_id
                    )
                  ),
                ]),
              ]),
              _vm._v("\n        " + _vm._s(o.address) + "\n      "),
            ]),
            _vm._v(" "),
            _c(
              "td",
              _vm._l(o.details, function (detail) {
                return _c(
                  "div",
                  { staticClass: "drug_details" },
                  [
                    _c(
                      "p",
                      { staticClass: "flex" },
                      [
                        _vm.drugsImages[detail.drug_id]
                          ? _c(
                              "v-popover",
                              {
                                staticClass: "d-inline",
                                attrs: {
                                  placement: "bottom",
                                  "auto-hide": true,
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "icon-fa icon-fa-photo pointer mr-1",
                                }),
                                _vm._v(" "),
                                _c("template", { slot: "popover" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.drugsImages[detail.drug_id],
                                      alt: "",
                                    },
                                  }),
                                ]),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(
                          "\n            " +
                            _vm._s(detail.drug.title) +
                            " (" +
                            _vm._s(detail.drug_id) +
                            ")\n            "
                        ),
                        detail.drug.cool
                          ? _c("span", { staticClass: "ml-1" }, [
                              _c("i", { staticClass: "icon icon-snowflake" }),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(detail.drug.en_title)),
                    ]),
                    _vm._v(" "),
                    detail.drug.pack_comment
                      ? _c("p", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(detail.drug.pack_comment)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    detail.drug.pack_box_comment
                      ? _c("p", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(detail.drug.pack_box_comment)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    (detail.extra_data?.comments ?? []).length
                      ? _c(
                          "div",
                          { staticClass: "alert alert-warning p-1 mb-1" },
                          _vm._l(detail.extra_data.comments, function (c) {
                            return _c("p", [_vm._v(_vm._s(c.text))])
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    detail.pack_set !== 1
                      ? [
                          _c("p", [
                            _c("strong", [
                              _vm._v(
                                "x " + _vm._s(detail.qty / detail.pack_set)
                              ),
                            ]),
                            _vm._v(" (компл)"),
                            _c("strong", [
                              _vm._v(
                                " * " + _vm._s(detail.price * detail.pack_set)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [_vm._v("x " + _vm._s(detail.qty))]),
                            _vm._v(" завод. упак."),
                            _c("strong", [
                              _vm._v(" * " + _vm._s(detail.price)),
                            ]),
                          ]),
                        ]
                      : [
                          _c("p", [
                            _c("strong", [
                              _vm._v(
                                "x " +
                                  _vm._s(detail.qty) +
                                  " * " +
                                  _vm._s(detail.price)
                              ),
                            ]),
                          ]),
                        ],
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("td", [
              _c(
                "span",
                {
                  class: {
                    badge: true,
                    "badge-success": o.pay_method === 3,
                    "badge-dark": o.pay_method !== 3,
                  },
                },
                [_vm._v(_vm._s(o.no_cash_price))]
              ),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: o.pack_weight,
                    expression: "o.pack_weight",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "number", placeholder: "2000" },
                domProps: { value: o.pack_weight },
                on: {
                  change: function ($event) {
                    return _vm.updateOrder(o)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(o, "pack_weight", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              o.weight_added_at
                ? _c("p", { staticClass: "text-muted fs-12" }, [
                    _vm._v(_vm._s(_vm.printDate(o.weight_added_at))),
                  ])
                : _vm._e(),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }